import StudentAppBar from "../StudentAppBar";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { Link } from "react-router";
import AdmissionApi from "../../Services/AdmissionApi";
import Paging from "../Paging";
import StudentSideBar from '../StudentSideBar';
import ImgLoading from '../../assets/images/img-loading.gif'
import "./style.css";

class Careers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: window.innerWidth < 980 ? false : true,
      careers: [],
      selectedCareer: '',
      showLoading: true,
      imagesId: [],
      images: [],
      page: 1,
      pageSize: 10,
      totalPages: 1,
    };

    this.admissionsService = new AdmissionApi();
  }

  static get contextTypes() {
    return {
      router: PropTypes.object.isRequired,
    };
  }

  UNSAFE_componentWillMount() {
    const isLogin = localStorage.getItem("isLogin")

    if (isLogin == 1) {
      this.getAll();
    } else {
      this.context.router.push("/signIn");
    }
  }

  updateImageState = (newResponse) => {
    if (
      newResponse.data.images != undefined &&
      newResponse.data.images != null &&
      newResponse.data.images.length > 0
    ) {
      let images = [];
      let newCareers = [];

      let careers = this.state.careers;
      images = newResponse.data.images;
      if (newResponse.data.success) {
        careers.map((item, _index) => {
          images.map((obj, index) => {
            if (item.imageid != null || item.imageid != undefined) {
              if (item.imageid == obj.id) {
                item.imageurl = "https://media.notifyi.in/" + obj.url;
                newCareers.push(item);
              } else {
                // if (images.length == index + 1) {
                //   newCareers.push(item);
                // }
              }
            } else {
              if (newCareers.length > 0) {
                newCareers.forEach((newCar, i) => {
                  if (newCar.id == item.id) {
                  } else {
                    if (newCareers.length == i + 1) {
                      newCareers.push(item);
                    }
                  }
                });
              } else {
                newCareers.push(item);
              }
            }
          });
        });

        this.setState({ careers: newCareers, images: images });
      }
    }
  };

  updateState = (newResponse) => {
    let ids = [];
    let careers = [];
    careers = newResponse.data._embedded.careers;
    careers.map((item) => {
      ids.push(item.imageid);
    });

    let data = { images: ids };
    this.admissionsService.createMediaNew(
      this.updateImageState,
      data,
      "v1/media/images/get-all"
    );
    this.setState({
      careers: careers,
      imagesId: ids,
      showLoading: false,
      page: newResponse.data.page,
      totalPages: newResponse.data.pageCount
    });
  }

  getAll(page = 1) {

    let filters = ''
    const {
      selectedCareer,
      pageSize
    } = this.state

    if (selectedCareer) filters += `&text=${selectedCareer}`

    this.admissionsService.GetData(
      this.updateState,
      `v1/career?page=${page}&pageSize=${pageSize}&column=created_at&order=desc${filters}`
    );
  }

  handleFilterInputChange = (event) => {
    const { id, value } = event.target
    this.setState({
      [id]: value
    })
  }

  filterList = (e) => {
    e.preventDefault()
    this.getAll()
  }

  clearFilter = () => {
    this.setState({
      selectedCareer: ''
    }, this.getAll)
  }

  handlePageChange = (page) => {
    this.getAll(page)
  }

  createMarkup = (data) => {
    if (data) {
      if (data.substring().length > 70) {
        return { __html: data.substring(3, 70) + "..." };
      } else {
        return { __html: data.substring(3, 70) };
      }

    } else {
      return { __html: <p></p> };
    }
  }

  toggleSidebar = () => {
    this.setState(state => ({ isOpen: !state.isOpen }))
  }

  handleRequestChange = (isOpen) => {
    this.setState({ isOpen })
  }

  render() {

    const {
      page,
      totalPages,
      careers,
      selectedCareer,
      isOpen
    } = this.state

    return (
      <MuiThemeProvider>
        <div className="dash-container">
        <StudentSideBar isOpen={isOpen} handleRequestChange={this.handleRequestChange} />

          <div className="dash-content">
            <StudentAppBar title="Careers" toggleSidebar={this.toggleSidebar} router={this.props.router} />
            <div className="container">
              <section className="dash-alerts">
                <form>
                  <div className="alert-filter">
                    <input
                      id="selectedCareer"
                      value={selectedCareer}
                      type="text"
                      className="form-control alert-filter__input mr-2"
                      placeholder="Search for career"
                      onChange={this.handleFilterInputChange}
                    />
                    <button type="submit" onClick={this.filterList} className="btn btn--primary">
                      Submit
                    </button>
                    <button type="button" onClick={this.clearFilter} className="btn btn--default ml-2">
                      Clear
                    </button>
                  </div>
                </form>
                <table className="table table-responsive career-table alert-table">
                  <thead>
                    <tr>
                      <th scope="col">Career</th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {careers.map((item, i) => (
                      <tr key={item.id}>
                        <td className='career-body'>
                          <img className="career-img" src={item.imageurl ? item.imageurl : ImgLoading} alt={item.title} />
                          <div className="career-content">
                            <h3>
                              {item.title}
                              {/* <span className={`badge badge--success ml-1 ${i > 4 && 'd-none'}`}>New</span> */}
                            </h3>
                            <p className='d-none d-lg-block' dangerouslySetInnerHTML={this.createMarkup(item.domain)}></p>
                          </div>
                        </td>
                        <td>
                          <Link to={{ pathname: "/careerDetail", state: { data: item } }} className="alert-table__link">details</Link>
                        </td>
                      </tr>
                    ))}
                    {!careers.length && selectedCareer && (
                      <tr>
                        <td colSpan={2}>Searched keyword not found, please try searching with another keyword</td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <Paging page={page} totalPages={totalPages} onChange={this.handlePageChange} />
              </section>
            </div>
          </div>
        </div>
      </MuiThemeProvider>
    )
  }
}

export default Careers;



/** WEBPACK FOOTER **
 ** ./src/components/Careers/index.js
 **/